// Cookieless first-party analytics beacon. Sends page views on route change
// and periodic heartbeats while the tab is visible, so "time on site" is meaningful.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "invyt_sid";

function getSessionId() {
  try {
    let sid = localStorage.getItem(KEY);
    if (!sid) {
      sid = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 64);
      localStorage.setItem(KEY, sid);
    }
    return sid;
  } catch {
    return `anon-${Math.random().toString(36).slice(2, 12)}`;
  }
}

function send(type, path) {
  try {
    axios.post(`${API}/analytics/collect`, { session_id: getSessionId(), path, type }).catch(() => {});
  } catch {
    /* never let analytics break the app */
  }
}

export function trackPageView(path) {
  send("pageview", path);
}

let heartbeatStarted = false;
export function startHeartbeat() {
  if (heartbeatStarted) return;
  heartbeatStarted = true;
  setInterval(() => {
    if (document.visibilityState === "visible") {
      send("heartbeat", window.location.pathname);
    }
  }, 20000);
}
